import React from 'react';
import { Icon, Button } from 'components';
import { useSelect, useAction } from 'hooks';
import { withForm, withFormValidation } from 'hoc';
import { get } from 'lodash';
import { useHistory } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import OTPTimer from './OtpTimer';

const initState = {
  otp: ''
}

function Otp({ value,  onSetForm }) {

  const history = useHistory()
  const isLoading = useSelect('loading.isLoading', { type: 'auth.validateOtp' })
  const isLoadingValidateOtp = useSelect('loading.isLoading', { type: 'auth.ValidateOtpForgotPassword' })
  const validateOTPAction = useAction('auth.validateOtp')

  const validateOTPForgotPasswordAction = useAction('auth.ValidateOtpForgotPassword')

  const handleSubmit = e => {
    e.preventDefault()

    if(history.location.state.url === '/sign-up'){
      validateOTPAction({
        mobile_number: history.location.state.mobile_number,
        password: history.location.state.password,
        pin: value.otp
      }, () => {
        localStorage.removeItem('otp_running_seconds')
        history.replace('/')
      })
    }

    if(history.location.state.url === '/forgot-password'){
      validateOTPForgotPasswordAction({
        mobile_number: history.location.state.mobile_number,
        pin: value.otp
      }, () => {
        localStorage.removeItem('otp_running_seconds')
        history.replace({
          pathname: '/reset-password',
          state: {
            mobile_number: history.location.state.mobile_number
          }
        })
      })
    }

  }

  const onChangeOtp = e => {
    onSetForm({
      otp: e
    })
  }

  const mobileNumberArr = history.location.state.mobile_number.split("")
  mobileNumberArr.splice(2, 5, 'XXXXX')

  return (
    <div className="login-container">
      <div className="form-container">
        <form className="form w-full flex flex-grow" onSubmit={handleSubmit}>
          <div className="xl:!hidden lg:!hidden flex flex-col items-center justify-center flex-grow">
            <Icon.Logo className="lw-36 h-36"/>
            <span className="text-xs text-center">Land Transportation Franchising & Regulatory Board</span>
            <span className="text-sm font-bold text-center">Online Application and Issuance of Certificate of Public Convenience</span>
          </div>
          <div className="hidden xl:flex lg:flex flex-grow justify-center">
            <Icon.Logo className="lw-36 h-36"/>
          </div>

          <p className="text-sm my-2 font-medium">
          Enter the 6-digit code we sent to <b>{mobileNumberArr.join("")}</b> to verify your account
        </p>
          <div className="account-input-container">
            <OtpInput
              isInputNum
              shouldAutoFocus
              containerStyle="flex space-x-2 items-center justify-between"
              inputStyle="otp-input"
              value={value.otp}
              numInputs={6}
              onChange={onChangeOtp}
            />
          </div>
          <Button
            type="submit"
            isLoading={isLoading || isLoadingValidateOtp}
            disabled={!get(value, 'otp') || get(value, 'otp').length < 6}
            className="!bg-warning !rounded-none !text-black h-12 xl:!mt-16 mt-5"
          >
            <span>Verify</span>
          </Button>
          <OTPTimer />
        </form>
      </div>
      <div className="brand xl:!flex lg:!flex !hidden">
        <div className="content">
          <span className="title">Land Transportation Franchising & Regulatory Board</span>
          <span className="sub-title">Online Application and Issuance of Certificate of Public Convenience</span>
        </div>
      </div>
    </div>
  );
}


export default withForm(withFormValidation(Otp,
  {
    otp: 'required'
  },
), initState);
